var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStress1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 576.27 252.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-27{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ebeff1;}.cls-4{fill:#d7dde1;}.cls-5{fill:#ff3000;}.cls-16,.cls-6{font-size:18px;fill:#053b5c;}.cls-6{font-family:Omnes-Medium, Omnes;font-weight:500;}.cls-7{letter-spacing:-0.02em;}.cls-8{letter-spacing:-0.01em;}.cls-9{letter-spacing:0em;}.cls-10{letter-spacing:0em;}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:-0.02em;}.cls-15{letter-spacing:-0.01em;}.cls-16{font-family:Omnes-Regular, Omnes;}.cls-17{letter-spacing:0em;}.cls-18{letter-spacing:-0.01em;}.cls-19{letter-spacing:-0.01em;}.cls-20{letter-spacing:-0.01em;}.cls-21{letter-spacing:-0.01em;}.cls-22{letter-spacing:-0.01em;}.cls-23{letter-spacing:-0.01em;}.cls-24{letter-spacing:0em;}.cls-25{letter-spacing:-0.05em;}.cls-26{letter-spacing:0.02em;}.cls-27{stroke:#053b5c;stroke-miterlimit:10;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.27,222C445,222,445,14,313.77,14S182.52,222,51.27,222Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.27,222C445,222,445,14,313.77,14S182.52,222,51.27,222"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.27,
    y: 14,
    width: 85,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 136.27,
    y: 14,
    width: 75,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 193.83,
    y: 14,
    width: 71.44,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 265.02,
    y: 4,
    width: 95,
    height: 218
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 360.02,
    y: 14,
    width: 88.75,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 448.77,
    y: 14,
    width: 127.5,
    height: 208
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(98.58 247.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 9.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.16,
    y: 0
  }, "w")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(0 203.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 9.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.16,
    y: 0
  }, "w")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(189.73 247.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.56,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 23.8,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 34.28,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 43.96,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 50.58,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 59.65,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.06,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(495.71 170.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17"
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 10.92,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 20.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 26.57,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 36.29,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 46.3,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.91,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(334.73 247.59)"
  }, "H", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.33,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 16.24,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.03,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(0.41 22.8)"
  }, "H", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.33,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 16.24,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.03,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(449.65 247.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 10.3,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 19.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27,
    y: 0
  }, "y H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 51.35,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 55.26,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.04,
    y: 0
  }, "h"))), /*#__PURE__*/React.createElement("g", {
    id: "axis"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "576.27 222 51.27 222 51.27 0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress1);
export default __webpack_public_path__ + "static/media/stress1.8496b395342ca431b919f96e4fe3f3fe.svg";
export { ForwardRef as ReactComponent };